<nes-tooltip nes-id="id">
  <div [innerHtml]="textOrKey | translate"></div>
</nes-tooltip>